import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h3 mt-3 mb-6 title"
}
const _hoisted_2 = { class: "text-subtitle-1" }




export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
  title: { type: String, default: null },
  text: { type: String, default: null },
  fullWidth: Boolean,
  narrow: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container mb-2 bcl-page-header", { narrow: __props.narrow }])
  }, [
    _createVNode(_component_v_card, { class: "inner" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (__props.title || _ctx.$slots.title)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    _createTextVNode(_toDisplayString(__props.title), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: __props.fullWidth ? 12 : 9,
                  xl: __props.fullWidth ? 12 : 7
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "text", {}, () => [
                      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["md", "xl"])
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 2))
}
}

})